import { createAsyncThunk } from '@reduxjs/toolkit';
import { AuthService } from '@/Module/Auth/Service';
import { CookieService } from '@/Module/Core/Service';
export const postFreeTrialAction = createAsyncThunk<boolean, string | undefined>('Auth/postFreeTrial', async (_, {
  signal
}) => {
  const accessToken = CookieService.getAccessToken();
  return AuthService.postFreeTrial(accessToken, {
    disableResponseAutoError: true
  }, signal).then(data => data.data.isSuccess);
});